import { render } from "./KisiMusteri.vue?vue&type=template&id=3c40ba0f&scoped=true"
import script from "./KisiMusteri.vue?vue&type=script&lang=js"
export * from "./KisiMusteri.vue?vue&type=script&lang=js"

import "./KisiMusteri.vue?vue&type=style&index=0&id=3c40ba0f&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c40ba0f"]])

export default __exports__